<script>
export default {
    name: "TransferCycleModal",
    data() {
        return {
            transferCycle: this.$store.state.data.cycle,
            cycles: [],
        };
    },
    methods: {
        async getData(){
            var cycles = [];
            this.$store
                .dispatch("cycle/GetAllCycle")
                .then((res) => {
                    res.data.forEach((item) => {
                        cycles.push({ value: item.year, text: item.year });
                    });
                    this.cycles = cycles;
                })
                .catch(() => {
                    this.showToast("Something went wrong!","error");
                });
        },
        async transferCycleSubmit() {
            this.$emit("transferCycle", this.transferCycle);
        },
    },
};
</script>
<template>
    <b-modal
        id="transfer-cycle-modal"
        title="Transfer to another Cycle"
        size="sm"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form @submit.prevent="transferCycleSubmit" class="needs-validation">
            <div class="mb-3">
                <label for="cycle">Select Cycle </label>
                <select class="form-select" v-model="transferCycle">
                    <option v-for="y in cycles" :key="y.value" :value="y.value">{{y.text}}</option>
                </select>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    Transfer
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('transfer-cycle-modal')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>